// 用户存，流程导航
<template>
  <div class="flow userSaveFlow">
    <ul
      class="nav"
      :style="{backgroundPositionY: -(index-1) + 'rem'}">
      <li class="li" :class="{active : index == 1}">1. 身份认证<span></span></li>
      <li class="li" :class="{active : index == 2}">2. 扫码投递</li>
      <li class="li" :class="{active : index == 3}">3. 存入物品完成</li>
      <!-- <li class="li" :class="{active : index == 4}">4. 存入物品完成</li> -->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'userFastSaveFlow',
  data () {
    return {
      index: this.$store.state.mail_index
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  },
  watch: {
    '$store.state.mail_index': function (newVal) {
      this.index = newVal
      console.log('newVal', newVal)
    }
  }
}
</script>

<style scoped>
.flow.userSaveFlow .nav{
  width: 15.64rem;
  background-image: url(../../../../static/mailBox/images/flow/userFastSaveFlow.png);
  background-repeat: no-repeat;
  background-position-x: 0;
  background-size: 15.64rem 4rem;
}

.flow.userSaveFlow .nav .li {
  width: 33.3%;
}

/* .flow.userSaveFlow .nav .li:last-child {
  display: none;
} */
</style>



// WEBPACK FOOTER //
// src/components/mailBox/userFastSave/userFastSaveFlow.vue